import { MEDICATION_STATUSES } from '../../../constants/medicationStatuses';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as requestInitialState,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'patient-portal-medications',
  ['LOAD_MORE'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'ccd',
    'medications',
    {
      type: 'payload.query',
      queryParameter: 'status',
      selector: 'status',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
});

const { ACTIVE } = MEDICATION_STATUSES;

const initialState = {
  ...requestInitialState,
  total: 0,
  list: { active: [], discontinued: [] },
};

const requestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SEND:
      return {
        ...state,
        succeed: false,
        sending: true,
      };
    case consts.SUCCEED: {
      const status = payload.length && payload[0].status.toLowerCase();
      return {
        ...state,
        succeed: true,
        sending: false,
        list:
          status === ACTIVE
            ? { ...state.list, active: payload }
            : {
                ...state.list,
                discontinued: state.list.discontinued.concat(payload),
              },
      };
    }
    case consts.ADD_META:
      return { ...state, total: payload.total };
    case consts.CLEAR:
      return { ...initialState };
    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/medications-req.js